import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ACCESS_KEY = "pr_access_token";
const REFRESH_KEY = "pr_refresh_token";

export const tokenStore = {
    get access() {
        return localStorage.getItem(ACCESS_KEY) || "";
    },
    get refresh() {
        return localStorage.getItem(REFRESH_KEY) || "";
    },
    set(access, refresh) {
        if (access) localStorage.setItem(ACCESS_KEY, access);
        if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
    },
    clear() {
        localStorage.removeItem(ACCESS_KEY);
        localStorage.removeItem(REFRESH_KEY);
    },
};

const api = axios.create({
    baseURL: API_BASE,
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    const t = tokenStore.access;
    if (t) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${t}`;
    }
    return config;
});

let refreshing = null;

api.interceptors.response.use(
    (r) => r,
    async (err) => {
        const status = err?.response?.status;
        const original = err?.config;
        if (status === 401 && !original?._retried && tokenStore.refresh) {
            original._retried = true;
            try {
                if (!refreshing) {
                    refreshing = axios
                        .post(`${API_BASE}/auth/refresh`, {
                            refresh_token: tokenStore.refresh,
                        })
                        .finally(() => {
                            const cur = refreshing;
                            // small delay so concurrent calls share
                            setTimeout(() => {
                                if (refreshing === cur) refreshing = null;
                            }, 0);
                        });
                }
                const { data } = await refreshing;
                tokenStore.set(data.access_token, null);
                original.headers["Authorization"] = `Bearer ${data.access_token}`;
                return api(original);
            } catch (e) {
                tokenStore.clear();
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
